module.exports = __webpack_public_path__ + "static/ankush-f0f776f9824cab5f622a2dcdc3bdb7f2.jpg";